export const safeTransferFromAbi = {
  inputs: [
    { internalType: "address", name: "from", type: "address" },
    { internalType: "address", name: "to", type: "address" },
    { internalType: "uint256", name: "tokenId", type: "uint256" },
  ],
  name: "safeTransferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function",
};

export const withdrawalTokenAbi = {
  inputs: [
    { internalType: "address", name: "nftContractAddress", type: "address" },
    { internalType: "uint256", name: "tokenIdentifier", type: "uint256" },
  ],
  name: "withdrawalToken",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function",
};

export const unstakeAbi = {
  inputs: [
    {
      components: [
        { internalType: "address", name: "contractAddress", type: "address" },
        { internalType: "uint256", name: "tokenIdentifier", type: "uint256" },
      ],
      internalType: "struct BowlineMonsterStakingCave.TokenData[]",
      name: "_tokens",
      type: "tuple[]",
    },
  ],
  name: "unstake",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function",
};

export const stakeAbi = {
  inputs: [
    {
      components: [
        {
          internalType: "address",
          name: "contractAddress",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenIdentifier",
          type: "uint256",
        },
      ],
      internalType: "struct BowlineMonsterStakingCave.TokenData[]",
      name: "_tokens",
      type: "tuple[]",
    },
  ],
  name: "stake",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function",
};

export const stakerStatsAbi = {
  inputs: [
    { internalType: "address", name: "_stakerAddress", type: "address" },
  ],
  name: "stakerStats",
  outputs: [
    { internalType: "uint256", name: "totalTokensStaked", type: "uint256" },
    { internalType: "uint256", name: "unclaimedRewards", type: "uint256" },
    { internalType: "uint256", name: "unaccountedRewards", type: "uint256" },
    { internalType: "uint256", name: "lifetimeRewards", type: "uint256" },
  ],
  stateMutability: "view",
  type: "function",
};

export const stakedTokensForAddressAbi = {
  inputs: [
    { internalType: "address", name: "holder_address", type: "address" },
    { internalType: "uint256", name: "position", type: "uint256" },
  ],
  name: "stakedTokensForAddress",
  outputs: [
    { internalType: "address", name: "contractAddress", type: "address" },
    { internalType: "uint256", name: "tokenIdentifier", type: "uint256" },
    { internalType: "uint256", name: "lastRewardedAt", type: "uint256" },
    { internalType: "uint256", name: "stakedAt", type: "uint256" },
  ],
  stateMutability: "view",
  type: "function",
};

export const estimateRewardsAbi = {
  inputs: [
    {
      internalType: "address",
      name: "nftContractAddress",
      type: "address",
    },
    { internalType: "uint256", name: "tokenId", type: "uint256" },
  ],
  name: "estimateRewardsForToken",
  outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
  stateMutability: "view",
  type: "function",
};

export const claimRewardsAbi = {
  inputs: [],
  name: "claimRewards",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function",
};

export const balanceOfAbi = {
  inputs: [{ internalType: "address", name: "tokenHolder", type: "address" }],
  name: "balanceOf",
  outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
  stateMutability: "view",
  type: "function",
};

export const setApprovalForAll = {
  inputs: [
    { internalType: "address", name: "operator", type: "address" },
    { internalType: "bool", name: "approved", type: "bool" },
  ],
  name: "setApprovalForAll",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function",
};

export const isApprovedForAll = {
  inputs: [
    { internalType: "address", name: "owner", type: "address" },
    { internalType: "address", name: "operator", type: "address" },
  ],
  name: "isApprovedForAll",
  outputs: [{ internalType: "bool", name: "", type: "bool" }],
  stateMutability: "view",
  type: "function",
};

export const totalTokensStakedABI = {
  inputs: [
    { internalType: "address", name: "_stakerAddress", type: "address" },
  ],
  name: "stakerStats",
  outputs: [
    { internalType: "uint256", name: "totalTokensStaked", type: "uint256" },
    { internalType: "uint256", name: "unclaimedRewards", type: "uint256" },
    { internalType: "uint256", name: "unaccountedRewards", type: "uint256" },
    { internalType: "uint256", name: "lifetimeRewards", type: "uint256" },
  ],
  stateMutability: "view",
  type: "function",
};

export const totalTokensStakedCountAbi = {
  inputs: [],
  name: "totalTokensStakedCount",
  outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
  stateMutability: "view",
  type: "function",
};
